import React from "react";
import cx from "classnames";

// mappingName is the value assigned to this field (a column from the attached file)
const MappingTag = ({ mappingName, editing, edited, onRemove }) => {
  if (!mappingName) {
    if (!editing) return null;

    return (
      <div className="mapping__group__assignment__dropzone__placeholder">Drop your column here</div>
    );
  }

  return (
    <div className="mapping__group__assignment__dropzone__items">
      <div
        className={cx("tag tag--outline-bg-white tag--max-height tag--square tag--lowercase", {
          "tag--outline-bg-white--green": edited,
        })}
      >
        {mappingName}
      </div>
      {editing && (
        <div
          className="btn mapping__group__assignment__dropzone__items__btn-action btn--default-align"
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          onClick={onRemove}
        >
          <div className="solid solid-budicon-trash" />
        </div>
      )}
    </div>
  );
};

export default MappingTag;
